var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-about-partners-item"},[_c('a',{staticClass:"plugin-about-partners-item__container",attrs:{"href":_vm.url,"target":"_blank"}},[_c('div',{staticClass:"plugin-about-partners-item__image",style:(_vm.backgroundStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }